import React, { useState, useEffect, useContext } from 'react';
import { compose } from 'recompose';
import { observer } from 'mobx-react';

import UserContext from '../../../../../context/UserContext';
import useComponentMounted from '../../../../../hooks/useComponentMounted';
import Announcement from '../../../../Model/Announcement';
import LoadingOverlay from '../../../../components/LoadingOverlay';

import AnnouncementItem from './components/AnnouncementItem';
import {
  Container,
  EmptyContainer,
} from './styles';
import texts from './texts.json';

const AnnouncementList = () => {
  const { userId: coachId } = useContext(UserContext);

  const isComponentMountedRef = useComponentMounted();

  const [announcementCollection, setAnnouncementCollection] = useState({ docs: [] });
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      const announcementCol = await Announcement.getAnnouncementsByCoach(coachId);
      if (isComponentMountedRef.current) {
        setAnnouncementCollection(announcementCol);
        setIsReady(true);
      }
    };

    if (coachId) {
      init();
    }
  }, [
    coachId,
    isComponentMountedRef,
  ]);

  if (isReady && announcementCollection.docs.length === 0) {
    return (
      <EmptyContainer>
        {texts.noAnnouncements}
      </EmptyContainer>
    );
  }

  return (
    <Container $isReady={isReady}>
      {announcementCollection.docs.map((announcement) => (
        <AnnouncementItem key={announcement.id} announcement={announcement} />
      ))}
      <LoadingOverlay isLoading={!isReady} />
    </Container>
  );
};

export default compose(
  observer,
)(AnnouncementList);
